// Payment System v3.0 (WS2) — payoff run API client. Loan-scoped:
// POST /api/loans/{id}/payoff. The orchestrator computes the full settlement
// internally (arrears + fees + 3% prepayment admin fee + YMP), returns the
// remaining principal to the seller, and retires the loan.

import { api } from "@/api/client";

export interface PayoffRunRequest {
  /** ISO date (yyyy-MM-dd). Defaults to today server-side when omitted. */
  payoffDate?: string | null;
  externalReference?: string | null;
  notes?: string | null;
}

export interface PayoffResponse {
  paymentId: string;
  loanEventId: string;
  wasAlreadyProcessed: boolean;
  outstandingPrincipal: number;
  prepaymentAdminFee: number;
  yieldMaintenancePremium: number;
  accruedInterest: number;
  openArrears: number;
  grossSettled: number;
  totalDistributed: number;
  disbursementsCount: number;
}

export const payoffApi = {
  run: (loanId: string, body: PayoffRunRequest) =>
    api.post<PayoffResponse>(`/loans/${loanId}/payoff`, body),
};
